import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

export type FormFillErrorType = 'expired' | 'completed' | 'withdrawn' | 'unknown';

@Component({
  selector: 'app-global-form-fill-error',
  templateUrl: './global-form-fill-error.component.html',
  styleUrls: ['./global-form-fill-error.component.css'],
  imports: [...COMMON_IMPORTS],
  standalone: true,
})
export class GlobalFormFillErrorComponent implements OnInit {
  @Input() errorType: FormFillErrorType = 'unknown';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Get error type from route parameter if not provided as input
    const routeErrorType = this.route.snapshot.params['errorType'] as FormFillErrorType;
    if (routeErrorType && ['expired', 'completed', 'withdrawn', 'unknown'].includes(routeErrorType)) {
      this.errorType = routeErrorType;
    }
  }

  get errorTitle(): string {
    switch (this.errorType) {
      case 'expired':
        return 'Form Link Expired';
      case 'completed':
        return 'Form Already Completed';
      case 'withdrawn':
        return 'Form Withdrawn';
      case 'unknown':
      default:
        return 'Form Error';
    }
  }

  get errorMessage(): string {
    switch (this.errorType) {
      case 'expired':
        return 'This form link has expired and is no longer available for completion.';
      case 'completed':
        return 'This form has already been completed and cannot be filled out again.';
      case 'withdrawn':
        return 'This form has been withdrawn and is no longer available.';
      case 'unknown':
      default:
        return 'An error occurred while loading this form. The form may be expired, completed or withdrawn. Please contact support if the problem persists.';
    }
  }

  get errorIcon(): string {
    switch (this.errorType) {
      case 'expired':
        return 'pi pi-clock';
      case 'completed':
        return 'pi pi-check-circle';
      case 'withdrawn':
        return 'pi pi-ban';
      case 'unknown':
      default:
        return 'pi pi-exclamation-triangle';
    }
  }

  get errorIconColor(): string {
    switch (this.errorType) {
      case 'expired':
        return 'text-orange-500';
      case 'completed':
        return 'text-green-500';
      case 'withdrawn':
        return 'text-red-500';
      case 'unknown':
      default:
        return 'text-yellow-500';
    }
  }
}
